export default class DtoCmsObstacle {
    constructor(obj) {
        this.cmsId = obj.cmsId
        this.obstacleId = obj.obstacleId
        this.installationCode = obj.installationCode
        this.value = obj.value
        this.order = obj.order
    }
}
